import type { KnowledgeItem } from '../types';

export const criticalCharacterKnowledge: KnowledgeItem[] = [
  {
    id: 'char-zuo',
    type: 'character',
    title: '左',
    content: '左',
    pronunciation: 'zuǒ',
    meaning: '面向南时，东边的一侧；也常表示左手或左边。',
    source: '常用汉字补充',
    createdAt: '2026-09-21T00:00:00.000Z'
  },
  {
    id: 'char-you',
    type: 'character',
    title: '右',
    content: '右',
    pronunciation: 'yòu',
    meaning: '面向南时，西边的一侧；也常表示右手或右边。',
    source: '常用汉字补充',
    createdAt: '2026-09-21T00:00:00.000Z'
  }
];
